"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMediaFileKey = void 0;
const getMediaFileKey = (key) => {
    return `media/files/${key}`;
};
exports.getMediaFileKey = getMediaFileKey;
//# sourceMappingURL=file-storage.js.map